import axios from 'axios';

// Base URL for API
// const baseURL = import.meta.env.VITE_API_URL || 'https://fyhst3wuy2.execute-api.us-east-2.amazonaws.com/dev';
const baseURL = 'https://ycx2wdyct1.execute-api.us-east-2.amazonaws.com/dev';

// Create an Axios instance
const api = axios.create({
  baseURL,
});

// Request Interceptor: Add Authorization header and Content-Type dynamically
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (!(config.data instanceof FormData) && !config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => Promise.reject(error)
);

// Response Interceptor: Handle token-related errors
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      handleUnauthorizedError();
    }
    return Promise.reject(error);
  }
);

// Handle 401 errors: Refresh token or redirect to login
async function handleUnauthorizedError() {
  const refreshToken = localStorage.getItem('refresh_token');
  if (refreshToken) {
    try {
      const newToken = await refreshAccessToken(refreshToken);
      localStorage.setItem('token', newToken);
      window.location.reload(); // Retry requests with the new token
    } catch {
      logoutAndRedirect();
    }
  } else {
    logoutAndRedirect();
  }
}

// Logout and redirect to login
function logoutAndRedirect() {
  localStorage.removeItem('token');
  localStorage.removeItem('refresh_token');
  window.location.href = '/'; // Adjust for your routing
}

// Simulated function to refresh access token (replace with actual implementation)
async function refreshAccessToken(refreshToken: string) {
  const response = await api.post('/auth/refresh', { refreshToken });
  return response.data.data?.token;
}

export default api;
